import { Link } from 'react-router-dom';

const FEATURES = [
  {
    icon: 'ri-layout-grid-line',
    title: '作品大全',
    desc: '完整收录影视作品，海报、年份、类型一目了然。',
  },
  {
    icon: 'ri-filter-3-line',
    title: '多维筛选',
    desc: '类型、年代、国家组合筛选，快速定位目标影片。',
  },
  {
    icon: 'ri-book-open-line',
    title: '剧情详解',
    desc: '每部作品提供导演、片长、剧情简介等详细资料。',
  },
  {
    icon: 'ri-heart-3-line',
    title: '本地收藏',
    desc: '一键收藏感兴趣的作品，刷新页面后依然保留。',
  },
];

export default function IntroSection() {
  return (
    <section className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
      <div className="flex flex-col gap-10 lg:flex-row lg:items-center">
        <div className="lg:w-2/5">
          <span className="text-xs font-semibold uppercase tracking-widest text-accent-600">
            About
          </span>
          <h2 className="mt-1 text-xl font-bold text-foreground-950 md:text-2xl">
            关于本站
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            北条麻妃电影是一个面向影迷的影视内容展示平台，专注整理北条麻妃的影视作品资料与行业资讯。我们希望用清晰的结构、专业的分类和详实的剧情介绍，帮助观众更高效地查询与了解相关电影。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            本站所展示的作品资料均为演示样例，海报为示意图片，仅供内容展示与学习交流使用。
          </p>
          <Link
            to="/about"
            className="mt-6 inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
          >
            了解更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid flex-1 grid-cols-1 gap-3 sm:grid-cols-2 md:gap-4">
          {FEATURES.map((f, i) => (
            <div
              key={f.title}
              className="animate-fade-up rounded-lg border border-background-200 bg-background-50 p-4 md:p-5"
              style={{ animationDelay: `${i * 60}ms` }}
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                <i className={`${f.icon} text-lg`}></i>
              </span>
              <h3 className="mt-3 text-sm font-semibold text-foreground-950">{f.title}</h3>
              <p className="mt-1.5 text-xs leading-relaxed text-foreground-500">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}